import { getCookie } from '@browsing/utils';
import { PlusMembershipStatus, PlusMembershipType } from './types';
export var isPlusFeatureEnabled = function (config) { return config.isEnabled('plus'); };
export var isPlusCookieEnabled = function () { return getCookie('zl_plus') === 'true'; };
export var isPlusEnabled = function (config) {
    return isPlusFeatureEnabled(config) || isPlusCookieEnabled();
};
export var isPlusEligible = function (plusMembershipStatus) {
    return plusMembershipStatus === PlusMembershipStatus.Eligible;
};
export var isPlusMember = function (plusMembershipStatus) {
    return plusMembershipStatus === PlusMembershipStatus.Member;
};
var EDUCATIONAL_LOCATION_KEY = 'zl_plus_deeplink';
export var setEducationalLocationInSessionStorage = function () {
    try {
        // eslint-disable-next-line no-restricted-globals
        sessionStorage.setItem(EDUCATIONAL_LOCATION_KEY, location.pathname);
        // eslint-disable-next-line no-empty
    }
    catch (e) { }
};
export var getEducationalLocationFromSessionStorage = function () {
    try {
        var value = sessionStorage.getItem(EDUCATIONAL_LOCATION_KEY);
        sessionStorage.removeItem(EDUCATIONAL_LOCATION_KEY);
        return value;
    }
    catch (e) {
        return null;
    }
};
export var getPlusCTALabel = function (isSpeedyMarketEnabled, plusMembershipType) {
    if (isSpeedyMarketEnabled) {
        return 'getMoreWithPlusCTA';
    }
    // This CTA Label for plus terminated customers will be added in future.
    // if (
    //     plusMembershipType === PlusMembershipType.Base &&
    //     plusMembershipStatus === PlusMembershipStatus.Eligible
    // ) {
    //     return 'joinPlusMembershipCTA';
    // }
    if (plusMembershipType === PlusMembershipType.Trial) {
        return 'tryPlusMembershipCTA';
    }
    return 'joinPlusMembershipCTA';
};
